import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {ISocketMessage} from "../../models/socket"

interface ISocketState {
  message: string
  connected: boolean
  error: string
}

const initialState: ISocketState = {
  message: "",
  connected: false,
  error: ""
}

export const socketSlice = createSlice({
  name: "socket",
  initialState,
  reducers: {
    connecting() {},
    connected(state) {
      state.connected = true
    },
    disconnectSocket(state) {
      state.connected = false
    },
    receiveMessage(state, action: PayloadAction<any>) {
      state.message = action.payload
    },
    error(state, action: PayloadAction<any>) {
      state.connected = false
      state.error = action.payload
    }
  }
})

export default socketSlice.reducer